import React, { useState, useEffect, useRef } from 'react';
import '../../css/inviteFriends.css';
import IconShare from '../../assets/svg/iconShare.svg';
import IconCopy from '../../assets/svg/iconCopy.svg';  
import IconNotifySuccess from '../../assets/svg/mainIconNotifySuccess.svg';              
import { useMobileMediaQuery, useTabletMediaQuery } from '../../utils';
import moment from 'moment';
import 'moment/locale/pt';
import { toast } from "react-toastify";
import copy from "copy-to-clipboard";
import { RWebShare } from "react-web-share";
import adsOfferData from '../../mock/adsOffer.json'
import Slider from '../Sliders/Slider';
import useCodes from '../../hooks/useCodes';
import imgInviteFriends from '../../assets/img/onboarding/desktop/img-acumule-saldo-codigo-referal-desktop-tablet.png';
import imgInviteFriendsMobile from '../../assets/img/onboarding/mobile/img-acumule-saldo-codigo-referal-mobile.png';
import { FiCheckCircle } from "react-icons/fi";
import { useDispatch, useSelector } from 'react-redux';
import { setSessionId, setCookieId } from '../../features/onboardingData/onboardingUserData';
import { currencyFormat } from '../../utils';
import { AiOutlineStop } from "react-icons/ai";
import { errorHandling } from '../../utils';
import CustomButton from '../CustomButton';
import { useNavigate } from 'react-router-dom';

function InviteFriends() {

    const navigate = useNavigate();
    const isSessionId = useSelector((state) => state.onboardingUserData.isSessionId);
    const isCookieId = useSelector((state) => state.onboardingUserData.isCookieId);
    const [copyOfferCode, setCopyOfferCode] = useState('');
    const [iParametro, setParametro] = useState('');
    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const copyTextRef = useRef();
    const [dateEnd, setDateEnd] = useState('');
    const [amountOfferCode, setAmountOfferCode] = useState('');
    const { getImageAdsNum } = useCodes();

    const hadleBtnClickCopy = () => {
        const isCopy = copy(copyOfferCode);

        toast.dismiss();
        
        if (isCopy) {
            toast.success("Código copiado com sucesso!", {
                icon: <img src={IconNotifySuccess} alt="icon" className="toast_iconNotifySuccess" />
            });
        } else {
            toast.error("Lamentamos, mas neste momento, não conseguimos copiar o código. Por favor, tente mais tarde.", {
                icon: <AiOutlineStop/>
            });
        }
    };

    const handleShareCode = () => {
        toast.dismiss();

        toast.success("Código partilhado com sucesso!", {
            icon: <img src={IconNotifySuccess} alt="icon" className="toast_iconNotifySuccess" />
        })
    }

    const getInviteMember = async () => {
        try {
          const response = await fetch(`${process.env.REACT_APP_DEV_URL}/inviteMember/fetchGetInviteMember`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': 'PT-PT',
                'CookieId': `${isCookieId}`,
                'SessionId': `${isSessionId}`,
            },
            credentials: "include",
            mode: "cors",
          });
            if (response.ok === false) {
                errorHandling(response.status);
                return;
            }
            const result = await response.json();
            if (result.error.erroMsg === 'Success') {
                setCopyOfferCode(result.codCupao);
                setParametro(result.iParametro);
                setDateEnd(result.fimValidade);
                setAmountOfferCode(currencyFormat(result.valorCupao));
            }
        } catch (error) {
            if (!navigator.onLine) {
                errorHandling('NoInternet');
            } else if (error instanceof TypeError && error.message === "Failed to fetch") {
                errorHandling('CORS');
            } else {
                errorHandling();
            }
        }
    }

    useEffect(() => {
        getInviteMember();
    }, []);

    const handleAddNewCard = () => {
        navigate('/configuracoes/associar-cartao/tipo-de-associacao')
    }

    return (
        <>
        { !isTablet && (
            <>
            <div className={ isMobile ? 'mainImgViewInviteFriendsTablet' : 'mainImgViewInviteFriendsMobile'}>
                <img src={imgInviteFriends} alt="imagem" className={ isMobile ? "mainImgInviteFriendsTablet" : "mainImgInviteFriendsMobile"} />
            </div>
            </>
        )}
        <div className={ isTablet ? 'secondMainContainerInviteFriends' : ( isMobile ? 'secondMainContainerInviteFriendsTablet' : 'secondMainContainerInviteFriendsMobile') }>
            <div className={ isTablet ? 'firstSubMainContainerInviteFriends'  : ( isMobile ? 'firstSubMainContainerInviteFriendsTablet' : 'firstSubMainContainerInviteFriendsMobile') }>
                { iParametro === 'S' ?
                <> 
                    { copyOfferCode.length > 0 ?
                        <>
                        <div className='secondTitleViewInviteFriends'>
                            <div className={ isTablet ? 'textTitleRegular400InviteFriends' : 'textTitleRegular400InviteFriendsMobile' }>Ganhe saldo por cada amigo que convidar</div>
                        </div>
                        <div className='txtSecondTitleViewInviteFriends'>
                                <div className='textSecondTitleViewInviteFriends'>Partilhe este código e ganhe {amountOfferCode}€ em saldo. Quem ativar a Carteira Virtual com</div>
                                <div className='textSecondTitleViewInviteFriends'>este código também recebe {amountOfferCode}€ de saldo como oferta. O saldo será adicionado quando o seu amigo associar um cartão MULTIBANCO.</div>
                        </div>
                        <div className={ isTablet ? 'textFormViewInviteFriends' : 'textFormViewInviteFriendsMobile' }>
                            <div className='textWrapperInviteFriends'>
                                <div className={ isTablet ? 'secondTextWrapperInviteFriends' : 'secondTextWrapperInviteFriendsMobile' }>
                                    <input 
                                        ref={copyTextRef}
                                        className={ isTablet ? 'inputTextInviteFriends' : ( isMobile ? 'inputTextInviteFriendsTablet' : 'inputTextInviteFriendsMobile') }
                                        type="text" 
                                        placeholder={copyOfferCode}
                                        value={copyOfferCode}
                                        maxLength={30}   
                                        readOnly
                                        
                                    />
                                    <button 
                                        onClick={hadleBtnClickCopy}
                                        className='inputTextCopyIconInviteFriends'
                                    >
                                        <img src={IconCopy} alt="icon" className="copyIconInviteFriends" />
                                    </button>
                                </div>
                                <div>
                                    <span className='textSecondTitleViewInviteFriends'>O código é específico da sua Carteira Virtual e é válido até </span>
                                    <span className='textSecondTitleBoldViewInviteFriends'>{moment(dateEnd).format('DD/MM/YYYY')}.</span>
                                </div>
                            </div>
                        </div>
                        </>
                        :
                        <>
                        <div className='secondTitleViewInviteFriends'>
                            <div className={ isTablet ? 'textTitleRegular400InviteFriends' : 'textTitleRegular400InviteFriendsMobile' }>Ganhe saldo por cada amigo que convidar</div>
                        </div>
                        <div className='txtSecondTitleViewInviteFriends'>
                            <div className='textSecondTitleViewInviteFriends'>Associe um cartão MULTIBANCO à sua Carteira Virtual para poder convidar amigos e ganhar saldo.</div>
                        </div>
                        </>
                    }
                    <div className={ isTablet ? 'btnViewInviteFriends' : 'btnViewInviteFriendsMobile' }>
                        { copyOfferCode.length > 0 ?
                            <RWebShare
                                data={{
                                    text: `Ativa a Carteira Virtual Médis e utiliza o meu código de adesão ${copyOfferCode} para ganhar saldo. Acede em `,
                                    url: 'https://saude360.medis.pt/carteira-virtual',
                                    title: "Partilhar código",
                                }}
                                onClick={handleShareCode}
                            >
                                <button className='btnNextInviteFriends'>Partilhar código <img src={IconShare} alt="icon" className="checkedIconInviteFriends" /></button>
                            </RWebShare>
                            :
                            <CustomButton 
                                text={'Associar cartão'} 
                                textColor={'#00214D'}
                                onPress={handleAddNewCard} 
                                color={'#15D4B6'}
                            />
                        } 
                    
                    </div> 
                </>
                :
                <>
                    <div className='secondTitleViewInviteFriends'>
                        <div className={ isTablet ? 'textTitleRegular400InviteFriends' : 'textTitleRegular400InviteFriendsMobile' }>Ganhe saldo por cada amigo que convidar</div>
                    </div>
                    <div className='txtSecondTitleViewInviteFriends'>
                            <div className='textSecondTitleViewInviteFriends'>De momento, não existe nenhuma campanha ativa.</div>
                    </div>
                </>
                }
            </div>
            { isTablet && (
                <>
                <div className='mainFirstAlingViewInviteFriends'>
                    <div className='mainImgViewInviteFriends'>
                        <img src={imgInviteFriendsMobile} alt="imagem" className="mainImgInviteFriends" />
                    </div>
                </div>
                </>
            )}
        </div>

        {/* Start slider */}
        <div className={isTablet ? 'mainSecondViewContainerInviteFriendsSlider' : ( isMobile ? 'mainSecondViewContainerInviteFriendsSliderTablet' : 'mainSecondViewContainerInviteFriendsSliderMobile')}>
            <Slider
                listRespData={adsOfferData.offerAds}
                getImage={getImageAdsNum}
            />
        </div>
        {/* End slider */}
        </>       
    )
}

export default InviteFriends